//Handel Open Loader
export const OPEN_LOADER = "OPEN_LOADER";

//Handle Close Loader
export const CLOSE_LOADER = "CLOSE_LOADER";
